import classNames from 'classnames';
import React, { memo } from 'react';
import Heading, { HeadingTypes } from '../Heading/Heading';

interface GroupedArticleIndexPageResultsSideBarProps {
  summaryListTitle?: string;
  summaryListItems: string[];
  focussedSummaryListItem: string | null;
  summaryListItemWasClicked: (summaryListItem: string) => void;
}

const GroupedArticleIndexPageResultsSideBar: React.FC<
  GroupedArticleIndexPageResultsSideBarProps
> = ({
  summaryListTitle = undefined,
  summaryListItems,
  focussedSummaryListItem,
  summaryListItemWasClicked,
}) => {
  const scrollTo = (id: string): void => {
    const transformedId: string = id.toLowerCase().replaceAll(' ', '-');
    const sectionWithMatchingId: HTMLElement | null =
      document.getElementById(transformedId);
    if (sectionWithMatchingId) sectionWithMatchingId.scrollIntoView();
  };

  return (
    <aside className="absolute h-full py-24 space-y-10 pointer-events-auto">
      <div className="sticky top-6 space-y-10">
        {summaryListTitle && (
          <div className="text-center xl:text-left xl:max-w-[200px]">
            <Heading text={summaryListTitle} headingType={HeadingTypes.h3} />
          </div>
        )}
        {summaryListItems && (
          <ul className="space-y-10">
            {summaryListItems.map((summaryListItem: string) => (
              <li key={summaryListItem}>
                <button
                  className={classNames(
                    'text-text/body-tint font-bold hover:underline',
                    {
                      underline: summaryListItem === focussedSummaryListItem,
                    }
                  )}
                  onClick={() => {
                    scrollTo(summaryListItem);
                    summaryListItemWasClicked(summaryListItem);
                  }}
                >
                  {summaryListItem}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </aside>
  );
};

export default memo(GroupedArticleIndexPageResultsSideBar);
